"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var date_fns_1 = __importDefault(require("@date-io/date-fns"));
var CalendarToday_1 = __importDefault(require("@material-ui/icons/CalendarToday"));
var pickers_1 = require("@material-ui/pickers");
var lodash_1 = require("lodash");
var react_1 = __importDefault(require("react"));
var FormDatePicker = function (_a) {
    var fields = _a.fields, item = _a.item, values = _a.values, setFieldValue = _a.setFieldValue, changeField = _a.changeField, errors = _a.errors, locale = _a.locale;
    return (react_1.default.createElement(pickers_1.MuiPickersUtilsProvider, { utils: date_fns_1.default, locale: locale },
        react_1.default.createElement(pickers_1.DatePicker, { inputVariant: (item === null || item === void 0 ? void 0 : item.variant) || "outlined", fullWidth: true, disabled: item.disabled || false, id: item.idHtml || item.stateKey, label: item.label, format: item.mask || "dd/MM/yyyy", value: fields
                ? lodash_1.get(fields, item.stateKey, Date.now())
                : lodash_1.get(values, item.stateKey, Date.now()), onChange: function (e) {
                if (setFieldValue)
                    setFieldValue(item.stateKey, e || "");
                if (changeField)
                    changeField({
                        key: item.stateKey,
                        value: e || "",
                    });
            }, error: !!lodash_1.get(errors, item.stateKey, null) ||
                !!lodash_1.get(errors, item.error, null), helperText: lodash_1.get(errors, item.stateKey, null) ||
                lodash_1.get(errors, item.error, null), InputProps: {
                endAdornment: react_1.default.createElement(CalendarToday_1.default, null),
            }, disableFuture: item.disabledFuture, disablePast: item.disabledPast, minDate: item.minDate, maxDate: item.maxDate, okLabel: item.okLabel, cancelLabel: item.cancelLabel })));
};
exports.default = FormDatePicker;
//# sourceMappingURL=GenericFormDatePicker.js.map